import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import Control from "../Control";
import SelectFirm from "../SelectFirm/SelectFirm";

const FirmForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Company' : 'Add Company'}</div>
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='name'
                       label='Name'
                       value={data.name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='address'
                       label='Address'
                       value={data.address}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='city'
                       label='City'
                       value={data.city}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType={isFilter ? 'text' : 'email'}
                       name='email'
                       label='Email'
                       value={data.email}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  optionsType='states'
                                  optionKey='abbr'
                                  optionLabelKey='name'
                                  value={data.state}
                                  valueKey='state'
                                  label='State'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               valueType='text'
                               name='zip'
                               label='Zip'
                               value={data.zip}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='phone'
                       label='Phone'
                       value={data.phone}
                       handleParentChange={handleParentChange}
                />
                <SelectFirm theme={theme}
                            width={width}
                            value={data.parent_firm}
                            valueKey='parent_firm'
                            label='Parent Company'
                            data={data}
                            handleParentChange={handleParentDropdownChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='website'
                       label='Website'
                       value={data.website}
                       handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

FirmForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default FirmForm;